// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1jZ5U","actionsCol":"EnrolledClinics_actionsCol__w1yDY"};